import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

import "./styles.scss";

class CantidadSelector extends Component {
	constructor(props) {
		super(props);
		this.state = {
			cantidad: (props.cantidadDisponible === null ? props.cantidad : (props.cantidadDisponible > props.cantidad ? props.cantidad : props.cantidadDisponible)),
			cantidadInputValue: "",
			open: false,
			masCantidad: false,
			sinstock: false,
		}
	}

	static propTypes = {
		buttonComponent: PropTypes.any,
		cantidadDisponible: PropTypes.number,
		cantidad: PropTypes.number.isRequired,
		onChange: PropTypes.func.isRequired,
		className: PropTypes.string,
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.cantidad !== this.props.cantidad) {
			this.setState({ cantidad: nextProps.cantidad });
		}
	}

	toggleCantidad(e) {
		if(e!=undefined && e!=null){
			e.preventDefault();
			this.setState(prevState => {
				prevState.open = !prevState.open;
				prevState.sinstock = false;
				return prevState;
			}, () => {
				const { open, masCantidad } = this.state;
				if (open && masCantidad)
				this.cantidadInput.focus();
			});
		}
	}

    setCantidad(cantidad, toggle = false) {
        if (cantidad) {
            const { onChange } = this.props;
            const { cantidadDisponible } = this.props;
            let changed = false;
            this.setState(prevState => {
                if (cantidadDisponible === null || !cantidadDisponible || cantidadDisponible >= cantidad) {
                    prevState.cantidad = cantidad;
                    prevState.sinstock = false;
                    if (cantidad > 6) {
                        prevState.cantidadInputValue = cantidad;
                        prevState.masCantidad = true;
                    } else {
                        prevState.cantidadInputValue = null;
                        prevState.masCantidad = false;
                    }
                    changed = true;
                    if (toggle)
                        prevState.open = false;
                } else {
                    prevState.cantidad = this.state.cantidad;
                    prevState.sinstock = true;
                }
                return prevState;
            }, () => (onChange && changed ? onChange(cantidad) : null))
        }
    }

	onCantidadKeyDown(e) {
		let newNumber = parseInt(e.key);
		if (isNaN(newNumber) && e.keyCode > 40) {
			e.preventDefault();
			this.setState({ cantidadInputValue: parseInt(e.target.value) });
		} else if (e.keyCode === 13) {
			this.setCantidad(parseInt(e.target.value), true);
		}
	}

	incremento = () => {
		const cantidad = this.state.cantidad + 1;
		this.setCantidad(cantidad, true);
		this.toggleCantidad();
	};

	decremento = () => {
		const cantidad = this.state.cantidad - 1;
		this.setCantidad(cantidad, true);
		this.toggleCantidad();
	};

	render() {
		const { cantidad, open, masCantidad, sinstock, cantidadInputValue } = this.state;
		const { cantidadDisponible, buttonComponent, className } = this.props;
		return (
			<div className={"d-flex align-items-center"}>
						{buttonComponent ?
							buttonComponent :
							<Fragment>
								<div className="productQuantity">
									<a className="decremento" onClick={this.decremento} />
									<input maxLength="3" type="number" pattern="\d*" value={this.state.cantidad} min="0" max="999" />
									<a className="incremento" onClick={this.incremento} />
								</div>
								{
									false && cantidadDisponible > 0 &&
									<small>({cantidadDisponible} disponible{cantidadDisponible > 1 ? "s" : ""})</small>
								}
							</Fragment>}
			</div >
		);
	}
}

export default CantidadSelector;



// WEBPACK FOOTER //
// ./src/components/CantidadSelector/CantidadSelector.js